import { Component, computed, input, output, signal } from '@angular/core'
import { EngineerTrackingResponse } from '../../interfaces/engineer-tracking-response.interface'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { PhoneNumberPipe } from 'src/app/shared/pipes/phone-number.pipe'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'

@Component({
    selector: 'sf-tracking-information',
    imports: [ButtonComponent, FaIconComponent, PhoneNumberPipe],
    templateUrl: './tracking-information.component.html',
    styleUrl: './tracking-information.component.scss',
})
export class TrackingInformationComponent {
    engineerTracking = input.required<EngineerTrackingResponse>()
    directionsResult = input.required<google.maps.DirectionsResult>()
    onToggleShowInformation = output<boolean>()

    showInformation = signal(true)

    directionsLeg = computed(() => {
        const result = this.directionsResult()
        const leg = result?.routes[0]?.legs?.[0]

        if (!leg) return null

        const miles = this.convertMetersToMiles(leg.distance?.value ?? 0)
        const etaText = this.calculateETA(leg.duration?.value ?? 0)

        return { miles, time: etaText }
    })

    toggleShowInformation(): void {
        this.onToggleShowInformation.emit(!this.showInformation())
        this.showInformation.update((current) => !current)
    }

    convertMetersToMiles(meters: number): number {
        const miles = meters / 1609.344
        return Math.round(miles * 10) / 10
    }

    calculateETA(durationSeconds: number): string {
        const eta = new Date(Date.now() + durationSeconds * 1000)
        return eta.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })
    }
}
